import "./Compliance5.module.css";
import Header from "@/reusable_sections/Header";
import Compliance from "./sections/Compliance";
import Complianceresources from "./sections/Complianceresources";
import Footer from "@/reusable_sections/Footer";
export default function Compliance5Page() {
  return <div>
      <Header />
      <Compliance />
      <Complianceresources />
      <Footer />
    </div>;
}